var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Pagebody',{attrs:{"loading":_vm.loading,"subnav":_vm.$store.getters.subnavNames}},[_c('innerFill')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }